import moment from 'moment'

const toLocalWallClock = (value) => {
    // If server returns ISO with an explicit offset (e.g. "...Z"),
    // keep the wall-clock time and render it in the user's local timezone.
    const m = moment.parseZone(value)
    return m.utcOffset(moment().utcOffset(), true)
}

const moneyPart = (v, currency, rateType) => {
    if (v == null || String(v).trim() === '') return '—'
    return `${(rateType === "F" || rateType === "C" || rateType === "M") ? (currency === "EUR" ? "€" : "$") : ""}${v}${rateType === "P" ? "%" : ""}`
}

const ScheduledRateChangeBanner = ({ jobDate, affiliateRate, networkRate, displayRate, displayNetRate, currency = "USD", rateType = "F" }) => {
    if (!jobDate) return null

    // `jobDate` is stored without an explicit offset; treat it as local time for display
    // so the scheduled time matches what the user selected.
    const dateStr = toLocalWallClock(jobDate).format('YYYY-MM-DD HH:mm:ss')

    return (
        <div
            className="text-center py-2 px-3 mb-3 rounded small"
            style={{
                backgroundColor: '#dff6f8',
                border: '1px solid #5bc0de',
                color: '#0c6674',
            }}
        >            
            Rate scheduled to change on {dateStr} - {(parseFloat(displayRate) > 0 && parseFloat(displayNetRate) > 0) ? `${moneyPart(displayRate, currency, rateType)} / ${moneyPart(displayNetRate, currency, rateType)} [Display]` : `${moneyPart(affiliateRate, currency, rateType)} / ${moneyPart(networkRate, currency, rateType)}`} 
        </div>
    )
}

export default ScheduledRateChangeBanner
